































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { getSignatureServer, performanceServer } from '@/api/installServer';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import publishObjectPath from '@/util/configRegistry'; // 导入过渡函数

@Component({
  components: { CollapseTransition },
})
export default class Dialog2 extends Vue {
  private dialogVisible = false;
  // 表单数据
  private formData: any = {};
  private hiddenData: any = [];
  private hiddenForm: any = {};
  private hazardList: any = [];
  private allPeople: any = [];
  private checkContentIds: any = [];
  hazardStatus: any = {
    CREATED: '已创建',
    ISSUED: '已下发',
    RECTIFYING: '整改中',
    RECTIFIED: '已整改',
    FEEDBACK: '已反馈',
    FINISH: '已完成',
    REVIEW_FAIL: '复查不通过',
    OTHERWISE: '另行办结',
  }; // 隐患状态

  imgPath: any = publishObjectPath.imgPathWater;

  private activeName: any = 'safetyChecklist';

  private basicInfoShow: any = true;
  private checkInfoShow: any = true;
  private hazardListShow: any = true;

  private handleClick(tab: any, event: any) {
    if (this.activeName !== 'safetyChecklist') {
      this.hiddenForm = this.hiddenData.find((item: any) => item.id === this.activeName);
      this.getRectifyForm(this.hiddenForm.id);
    }
  }
  private getRectifyForm(id: any) {
    performanceServer.getRectifyForm(id).then((res: any) => {
      if (res.code === '200') {
        this.hazardList = res.data.hazards;
        this.hazardList.forEach((item: any) => {
          this.$set(item, 'hazardPic', []);
          this.$set(item, 'rectifyPic', []);
          this.$set(item, 'reviewPic', []);
          this.getSysFile(item);
        });
        this.hazardList.forEach((item: any, index: any) => {
          if (item.reviewStaffId) {
            this.$set(item, 'reviewStaffSignature', '');
            this.getStaffSignatureByStaffId(item);
          }
        });
        console.log(this.hazardList);
      } else {
        console.log(res.msg);
      }
    });
  }
  // 获取签名图片 根据人员id
  private getStaffSignatureByStaffId(data: any) {
    getSignatureServer.getStaffSignatureByStaffId(data.reviewStaffId).then((res: any) => {
      if (res.code === '200') {
        if (!res.data) {
          // this.$message.warning('当前人员暂无签名');
        } else {
          data.reviewStaffSignature = res.data.signature;
        }
      } else {
      }
    });
  }
  private getSysFile(data: any) {
    if (data.hazardPicture) {
      performanceServer.getSysFile(data.hazardPicture).then((res: any) => {
        if (res.code === '200' && res.data.length > 0) {
          data.hazardPic = res.data;
        }
      });
    }
    if (data.rectifyPicture) {
      performanceServer.getSysFile(data.rectifyPicture).then((res: any) => {
        if (res.code === '200' && res.data.length > 0) {
          data.rectifyPic = res.data;
        }
      });
    }
    if (data.reviewPicture) {
      performanceServer.getSysFile(data.reviewPicture).then((res: any) => {
        if (res.code === '200' && res.data.length > 0) {
          data.reviewPic = res.data;
        }
      });
    }
  }
  private showDialog(data: any) {
    this.getData(data.id);
    this.getCheckDetail(data.id);
    this.dialogVisible = true;
  }
  // 获取安全检查单详情
  private getCheckDetail(id: any) {
    // 查询安全检查任务详情
    performanceServer.getTemplateDetail(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        this.allPeople = this.unique(res.data.joinLeaderList.concat(res.data.joinStaffList));
        this.checkContentIds = res.data.hazards.filter((item: any) => item.itemId !== '');
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  private getData(id: any) {
    performanceServer.getRectifyFormDetail(id).then((res: any) => {
      if (res.code === '200') {
        this.hiddenData = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  private unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].staffId === arr[j].staffId || arr[i].staffId === undefined || arr[j].staffId === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }
  handleClose(done: any) {
    done();
  }
}
